import { Form, Input, Space } from "antd";

export const MultiLanguageInput = ({
  name,
  label,
}: {
  name: string;
  label?: string;
}) => {
  return (
    <Form.Item label={label} className="border rounded p-2">
      <Space
        className="grid grid-cols-3 gap-2"
        direction="horizontal"
        style={{ width: "100%" }}
      >
        <Form.Item
          name={[name, "en"]}
          label="English"
          rules={[{ required: true }]}
        >
          <Input placeholder="Enter English" />
        </Form.Item>
        <Form.Item
          name={[name, "ar"]}
          label="Arabic"
          rules={[{ required: true }]}
        >
          <Input
            style={{ textAlign: "right" }}
            placeholder="أدخل النص بالعربية"
          />
        </Form.Item>
        <Form.Item
          name={[name, "fr"]}
          label="French"
          rules={[{ required: true }]}
        >
          <Input placeholder="Entrez le texte en français" />
        </Form.Item>
      </Space>
    </Form.Item>
  );
};
